import {parsePhoneNumberFromString} from "libphonenumber-js/min";

export function formatPhoneNumber(value) {
    const phoneNumber = parsePhoneNumberFromString(value ?? "");
    if (!phoneNumber) {
        return undefined;
    }
    return phoneNumber.formatNational();
}

export function normalizePhoneNumber(value, defaultCountry) {
    const phoneNumber = parsePhoneNumberFromString(value ?? "", defaultCountry);
    if (!phoneNumber?.isValid()) {
        return undefined;
    }

    return phoneNumber.number;
}
